import styled from "@emotion/styled";
import Table from "@mui/material/Table";
import { makeStyles } from "@mui/styles";
import {
  COLOR_BLACK,
  COLOR_BLACK_10,
  COLOR_GREEN,
  COLOR_GREY_2,
  COLOR_GREY_6,
} from "shared/theme/colors";
import FlexCenter from "../Layout/components/FlexCenter";

export const StyledTable = styled(Table)`
  position: relative;
  &.MuiTable-root {
    outline: none;
    border: none;
    display: block;
    border-spacing: 0 24px;
    border-collapse: separate;
  }

  &.MuiTableBody-root {
    border-radius: 16px;
  }

  & .MuiTableCell-root {
    padding: 0 12px;
    border-bottom: none;
    &:first-child {
      padding: 0;
    }
  }

  .MuiTableRow-root td:first-child {
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;
    border-left: 1px solid ${COLOR_GREY_6};
    border-bottom: 1px solid ${COLOR_GREY_6};
    border-top: 1px solid ${COLOR_GREY_6};
    background-color: ${COLOR_GREY_2};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  }

  .MuiTableRow-root td:last-child {
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    border-right: 1px solid ${COLOR_GREY_6};
    border-bottom: 1px solid ${COLOR_GREY_6};
    border-top: 1px solid ${COLOR_GREY_6};
    background-color: ${COLOR_GREY_2};
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.12);
  }
`;

export const StyledSpinnerWrapper = styled(FlexCenter)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledEmptyWrapper = styled(FlexCenter)`
  background-color: ${COLOR_GREY_2};
  height: 140px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 1rem;
`;

export default makeStyles(() => ({
  noDataMessage: {
    "&.MuiAlert-root": {
      height: 58,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      backgroundColor: COLOR_GREEN,
      color: COLOR_BLACK,
      fontWeight: 500,

      "& .MuiAlert-icon": {
        color: COLOR_BLACK,
        marginRight: "0.625rem",
      },
    },
  },
}));

export const SkeletonContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

export const StyledSkeleton = styled("div")`
  animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite";
  border-radius: 10px;
  background-color: ${COLOR_BLACK_10};
  "@keyframes pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.5,
    },
  },
`;

export const ContentWrapper = styled("div")`
  padding: 24px 0;
`;
